import { Component, OnInit } from '@angular/core';
import { LanguageService } from '@ibank-globals/language/src/services/language.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '../../../globals/classes/base.component';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'business-registration-info-modal',
	template: require('./business-registration-info-modal.component.html'),
})
export class BusinessRegistrationInfoModalComponent extends BaseComponent implements OnInit {
	public title: string = 'Εγγραφή νέας επιχείρησης';
	public langId: string;
	public isRebrading = AppSettings.isRebrading;

	constructor(
		private _langSvc: LanguageService,
		private activeModal: NgbActiveModal,
		private modalService: NgbModal
	) {
		super();
	}
	ngOnInit(): void {
		this._initSubscriptions();
	}

	public closeModal(): void {
		this.activeModal.close();
	}

	public learnMore() {
		if (this.langId === 'el') {
			window.open(
				'https://www.nbg.gr/el/epaggelmaties/proionta-upiresies/digital-banking/anoigma-epaggelmatikou-logariasmou-online',
				'_blank'
			);
		} else {
			window.open(
				'https://www.nbg.gr/en/business/banking-products-services/digital-banking/customer-onboarding',
				'_blank'
			);
		}
	}

	private _initSubscriptions(): void {
		this.mortalize(this._langSvc.activeLanguage$).subscribe((lang) => (this.langId = lang));
	}
}
